import { useEffect, useState } from "react";
import { TrendingUp, MousePointerClick } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/context/LanguageContext";

export const TopSimulations = () => {
  const { t } = useLang();
  const s = t.dash.sims;
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/simulations/stats").then((res) => setData(res.data));
  }, []);

  if (!data || data.total === 0) return null;
  const max = Math.max(...data.top.map((x) => x.count), 1);

  return (
    <div className="border border-white/10 bg-[#111111] p-6 mb-10" data-testid="top-simulations">
      <div className="flex items-center justify-between mb-5">
        <p className="flex items-center gap-2 text-xs uppercase tracking-widest text-white/40">
          <TrendingUp className="w-4 h-4 text-[#FF7900]" /> {s.title}
        </p>
        <p className="text-xs text-white/30">{data.total} {s.total}</p>
      </div>
      <ul className="space-y-3">
        {data.top.map((row) => (
          <li key={row.label} data-testid={`sim-row-${row.label}`}>
            <div className="flex items-center justify-between text-sm mb-1.5">
              <span className="text-white/80 truncate pr-4">{row.label}</span>
              <span className="flex items-center gap-3 shrink-0 text-xs">
                <span className="text-white/50">×{row.count}</span>
                {row.cta > 0 && (
                  <span className="flex items-center gap-1 text-emerald-400">
                    <MousePointerClick className="w-3 h-3" /> {row.cta} {s.cta}
                  </span>
                )}
              </span>
            </div>
            <div className="h-1.5 bg-white/5 rounded-full overflow-hidden">
              <div className="h-full bg-[#FF7900] rounded-full transition-all duration-700" style={{ width: `${(row.count / max) * 100}%` }} />
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
